<template>
  <span v-if="exact" class="counter-pile" :title="`${count} counters`">
    <span class="counter-dot" />
    <span class="counter-count">{{ count }}</span>
  </span>

  <span v-else class="counter-pile" :title="bandTitle">
    <span
      v-for="n in bandDots"
      :key="n"
      class="counter-dot"
    />
    <span class="counter-band">{{ bandLabel }}</span>
  </span>
</template>

<script>
// A player's counter supply.
//
// Matt chose to hide opponents' counts (2026-08-26), which is what the
// rulebook itself asks for: "It's a good idea to keep your counters hidden.
// Most people hold them in their closed fists" (p2, HINT 4). So the human
// sees their own supply exactly and everyone else's as a coarse band.
//
// Zero used to be spelled out as "out", on the reasoning that a forced take
// is about to be public anyway and the rulebook's Tip 3 tells you to watch
// for it. Matt reversed that (2026-09-18): "it's telling me that one of them
// is out of tokens and that shouldn't be known. It should be a secret."
// Tip 3 says to PAY ATTENTION, which is an instruction to the player, not a
// readout the game owes them - and announcing it hands over the one piece of
// bookkeeping that actually decides a turn. An empty-handed opponent is now
// just the bottom of "low", and you find out when they take the card.
//
// Worth being honest about what "hidden" buys: counts are perfectly
// DERIVABLE. Every decline spends exactly one counter and every take
// collects a known pile, so a determined player can track all of it. Hiding
// them doesn't create secret information, it just declines to do the
// bookkeeping for you - which is the tension the printed game has too.
const BANDS = [
  { max: 3, label: 'low', dots: 1 },
  { max: 7, label: 'some', dots: 2 },
  { max: Infinity, label: 'plenty', dots: 3 },
];

export default {
  name: 'CounterSupply',
  props: {
    count: { type: Number, required: true },
    // True only for the human's own supply.
    exact: { type: Boolean, default: false },
  },
  computed: {
    band() {
      return BANDS.find((b) => this.count <= b.max);
    },
    bandLabel() { return this.band.label; },
    bandDots() { return this.band.dots; },
    // The tooltip is as coarse as the label. It used to say "Out of counters
    // — must take the next card", which leaked the whole secret to anyone who
    // hovered.
    bandTitle() { return `Counters: ${this.bandLabel}`; },
  },
};
</script>
